<article>
  <section class="py-5">
    <div class="container">
      <h1>Request Access to Adobe Creative Cloud</h1>

      <form class="card p-4 mt-4"
            id="adobe-cc-request-form">
        <fieldset>

          <legend>
            {{question1}}
            <span class="d-block fw-normal fs-5">(Check all that apply)</span>
          </legend>

          @for (app of adobeApplications; track app) {
            <div class="form-check">
              <label class="form-label">
                <input class="form-check-input"
                       id="adobe-{{app.replace(' ', '-')}}"
                       [ngModel]="desiredApps()[app]"
                       (ngModelChange)="updateDesiredApps(app, $event)"
                       type="checkbox"
                       name="desiredApps"
                       value="{{app}}" />
                {{app}}
              </label>
            </div>
          }

          <div class="form-check form-check-inline">
            <label class="form-label">
              <input class="form-check-input"
                     id="adobe-other"
                     [ngModel]="desiredApps()['Other']"
                     (ngModelChange)="updateDesiredApps('Other', $event)"
                     type="checkbox"
                     name="desiredApps" />
              <span class="me-2">
                    Other:
              </span>
            </label>

            <label class="visually-hidden" for="otherText">
              Fill in Other:
            </label>
            <input class="form-control form-control-sm d-inline w-auto"
                   id="otherText"
                   [ngModel]="desiredApps()['OtherText']"
                   (ngModelChange)="updateDesiredApps('OtherText', $event)"
                   name="otherText"
                   type="text"
                   [disabled]="desiredApps()['Other'] === false"
            />
          </div>

        </fieldset>

        <label class="form-label fs-5 mt-3"
               for="cc-justification">
          {{question2}}
        </label>
        <textarea class="form-control"
                  id="cc-justification"
                  rows="3"
                  name="justification"
                  [(ngModel)]="justification"
        >
        </textarea>

        <div class="d-flex justify-content-center mt-3">
          <app-third-party [vendorName]="vendorName"
                           [name]="name"
                           [disableAuto]="true"
                           [answers]="answers()"
                           [validator]="validator">
          </app-third-party>
        </div>
      </form>

    </div>
  </section>
</article>
